import { render, staticRenderFns } from "./send-details.vue?vue&type=template&id=f2396724&scoped=true&"
import script from "./send-details.vue?vue&type=script&lang=js&"
export * from "./send-details.vue?vue&type=script&lang=js&"
import style0 from "./send-details.vue?vue&type=style&index=0&id=f2396724&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2396724",
  null
  
)

export default component.exports